"use client";

import { Target, Network, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const features = [{
  title: "Psicologia Clinica",
  description: "Analisi profonda dei comportamenti digitali e dei bias cognitivi che influenzano il ranking su Yandex e la conversione degli utenti russi.",
  icon: Target
}, {
  title: "Mediazione Nativa",
  description: "Adattamento culturale e linguistico di alto livello per superare le barriere del RuNet, garantendo una presenza autorevole e locale.",
  icon: Network
}, {
  title: "Sicurezza FZ-152",
  description: "Infrastrutture tecniche blindate e conformità totale alla legge russa sulla localizzazione dei dati, proteggendo la sovranità digitale.",
  icon: ShieldCheck
}];
export default function Features() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="225168" id="humanarchitecturebehindthemachine" className="bg-background py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Architettura Umana Dietro la Macchina
          </h2>
          <p className="font-default mt-6 text-lg leading-8 text-muted-foreground">
            RUSSEO integra competenze tecniche d'élite e sensibilità culturale per navigare i complessi ecosistemi digitali della CSI con precisione chirurgica.
          </p>
        </div>

        <div ref={gridRef} className={`mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:mt-20 lg:max-w-none lg:grid-cols-3 transition-all duration-1000 delay-200 ${isGridVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          {features.map((feature, i) => <Card key={i} data-index={i} className="flex flex-col justify-between border-border/50 bg-card/40 backdrop-blur-md shadow-sm transition-all duration-300 hover:shadow-lg hover:shadow-secondary/10 hover:border-secondary/50">
              <CardHeader className="pb-4 pt-8 px-8">
                <feature.icon className="mb-6 size-12 text-secondary" strokeWidth={1.5} aria-hidden="true" />
                <CardTitle className="font-default text-xl font-semibold text-foreground">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-8 pb-8 pt-0">
                <p className="font-default text-base leading-7 text-muted-foreground">
                  {feature.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}